/** Retired welcome routes now enter the existing Home experience. */
(() => {
  'use strict';
  if (window.Shopify?.designMode) return;
  const root = window.Shopify?.routes?.root || '/';
  const normalizeLinks = (scope = document) => {
    scope.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try { url = new URL(link.getAttribute('href'), location.origin); } catch (_) { return; }
      if (url.origin !== location.origin || !/\/pages\/benvenuto\/?$/.test(url.pathname)) return;
      const destination = new URL(root, location.origin);
      if (url.hash === '#ld-assistente' || url.searchParams.get('open_ai') === '1') destination.searchParams.set('open_ai', '1');
      link.setAttribute('href', destination.pathname + destination.search);
    });
  };
  const init = () => {
    normalizeLinks();
    const url = new URL(location.href);
    if (url.pathname !== root && url.pathname !== '/') return;
    const openAI = url.searchParams.get('open_ai') === '1';
    if (url.searchParams.has('ld_welcome') || openAI) {
      url.searchParams.delete('ld_welcome');
      url.searchParams.delete('open_ai');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
    if (!openAI) return;
    let attempts = 0;
    const attempt = () => {
      const trigger = document.querySelector('[data-ld-ai-source="home-intro"]');
      // The provider script can finish before its chat frame is mounted.
      const frame = document.querySelector('#flyweight-chat > iframe[title="Chat"], iframe[src*="assistant.flyweight.io"]');
      if (trigger && frame && window.LDDivettaAssistant?.open(trigger)) return;
      if (++attempts < 80) window.setTimeout(attempt, 125);
    };
    attempt();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => normalizeLinks(event.target));
})();
